import { CrudFormConfig } from '../edit-form/crud-form-config.interface';
import { FormLayout } from '../edit-form/form-layout.enum';

export const gridBuilderSettingsFormConfig: CrudFormConfig = {
  items: [],
  formLayout: FormLayout.Vertical,
};

